import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const CardHeader = (props) => {
  const {
    className,
    tag: Tag,
    status,
    ...attributes
  } = props;
  const cardHeaderClass = classNames('card-header', className, status && `text-${status}`);
  return (
    React.createElement(Tag, {...attributes, className: cardHeaderClass})
  );
};

CardHeader.propTypes = {
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  className: PropTypes.string,
  status: PropTypes.string
};

CardHeader.defaultProps = {
  tag: 'div'
};

export default CardHeader;
